import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmailSigninComponent } from './email-signin/email-signin.component';
import { ProviderLoginsComponent } from './provider-logins/provider-logins.component';
import { GoogleSigninDirective } from '../directives/google-signin.directive';
import { MicrosoftSigninDirective } from '../directives/microsoft-signin.directive';
import { LoaderComponent } from './loader/loader.component';

@NgModule({
  declarations: [
    GoogleSigninDirective,
    MicrosoftSigninDirective,
    EmailSigninComponent,
    ProviderLoginsComponent,
    LoaderComponent,
  ],
  imports: [CommonModule, ReactiveFormsModule, RouterModule],
  exports: [
    EmailSigninComponent,
    ProviderLoginsComponent,
    LoaderComponent,
    GoogleSigninDirective,
    MicrosoftSigninDirective,
  ],
})
export class PartialsModule {}
